import { PropsWithChildren, ReactElement, useCallback, useContext, useEffect } from "react";
import { useLoginMutation } from "../../../redux/apis/blenderApi";
import AppConflictScreen from "../../presenters/AppConfilctScreen";
import FullScreenSpinner from "../../presenters/FullScreenSpinner";
import { UserManagerContext } from "./UserManagerContext";

/**
 * Logs into BlenderGara upon launching the app.
 *
 * **Provider dependencies:**
 * - (Store) Provider
 */

export default function BlenderLoginHandler({ children }: PropsWithChildren): ReactElement {
  const userManager = useContext(UserManagerContext);

  const [loginToBlender, { data, isLoading }] = useLoginMutation();

  useEffect(
    () => { void loginToBlender(); },
    [loginToBlender],
  );

  const logout = useCallback(
    () => {
      void userManager.signoutRedirect();
    },
    [userManager],
  );

  if (!data || isLoading)
    return <FullScreenSpinner />;

  if (data.error === "MobileSessionInProgress")
    return <AppConflictScreen
      onRefresh={() => loginToBlender()}
      onSwitchAccount={logout}
    />;

  return <>{children}</>;
}
